import axios from "axios";
import { API, getSessionId } from "@/lib/api";

// Version du cache local. Toute montée de version purge les anciennes clés incompatibles
// pour que TOUS les téléphones se comportent de façon identique.
export const CACHE_VERSION = "v14";

const CACHED_KEYS = [
    "revanche_answers", "revanche_step", "revanche_analysis",
    "revanche_preview", "revanche_rescan", "revanche_first_report_dl",
    "revanche_account_test",
];

export function purgeCacheIfStale() {
    try {
        if (localStorage.getItem("gu_cache_v") !== CACHE_VERSION) {
            CACHED_KEYS.forEach((k) => localStorage.removeItem(k));
            localStorage.setItem("gu_cache_v", CACHE_VERSION);
        }
    } catch (e) { /* noop */ }
}

// Source de vérité unique. Ne jamais déduire l'abonnement/la progression du localStorage.
export async function fetchMe() {
    const sid = getSessionId();
    if (!sid) return null;
    try {
        const { data } = await axios.get(`${API}/me`, { params: { session_id: sid }, withCredentials: true });
        return data;
    } catch (e) { return null; }
}

export const creatorSimulatePay = () =>
    axios.post(`${API}/creator/simulate-pay`, null, { params: { session_id: getSessionId() } }).then((r) => r.data);
export const creatorSetLock = (locked) =>
    axios.post(`${API}/creator/set-lock`, null, { params: { session_id: getSessionId(), locked: locked ? 1 : 0 } }).then((r) => r.data);
export const creatorReset = () =>
    axios.post(`${API}/creator/reset`, null, { params: { session_id: getSessionId() } }).then((r) => r.data);
export const activateCreator = (token) =>
    axios.get(`${API}/creator/${encodeURIComponent(token)}`, { params: { session_id: getSessionId() }, withCredentials: true }).then((r) => r.data);

// Cache mémoire des données d'onglets : évite l'écran noir / l'affichage vide-puis-rempli.
const _cache = { me: null, home: null, account: null, referral: null, pricing: null, coach: null };
export const cachedMe = () => _cache.me;
export const cachedHome = () => _cache.home;
export const setCachedHome = (d) => { _cache.home = d; };
export const cached = (k) => _cache[k];
export const setCached = (k, v) => { _cache[k] = v; };

export async function prefetchAll() {
    // Préchargement pendant l'intro : on attend seulement `me` (nécessaire au routage),
    // puis on réchauffe TOUTES les données d'onglets en arrière-plan (rendu instantané ensuite).
    let me = null;
    try { me = await fetchMe(); _cache.me = me; } catch (e) { /* noop */ }
    (async () => {
        try {
            const pay = await import("@/lib/pay");
            pay.getPricing?.().then((d) => { _cache.pricing = d; }).catch(() => {});
            pay.getReferral?.().then((d) => { _cache.referral = d; }).catch(() => {});
            if (me && me.abonne) {
                pay.getHome?.().then((d) => { _cache.home = d; }).catch(() => {});
                pay.getAccount?.().then((d) => { _cache.account = d; }).catch(() => {});
                pay.coachStart?.().then((d) => { _cache.coach = d; }).catch(() => {});
            } else if (me && me.questionnaire_termine) {
                pay.getAccount?.().then((d) => { _cache.account = d; }).catch(() => {});
            }
        } catch (e) { /* noop */ }
    })();
    return me;
}
